export const fieldStatus = Object.freeze({
  EMPTY: "EMPTY",
  ERROR: "ERROR",
  VALID: "VALID"
})
